import React, { useContext, useState } from 'react'
import { BasePopupContext } from '../../hooks/usePopup';
import { FormattedMessage, useIntl } from 'react-intl';
import useApi from '../../hooks/useApi';
import { error_alert, getAuthUser, getToken, setToken, success_alert } from '../../utils';
import { network_tl } from '../../translations';
import { BiLoaderAlt } from 'react-icons/bi';
import Subscription from '.';
import { login } from '../../redux/slices/userSlice';
import { useDispatch } from 'react-redux';

const Cancel = ({data}) => {
  console.log("data", data)
  const [loading, setLoading] = useState(false);
  const intl = useIntl()
  const { Axios } = useApi();
  const dispatch = useDispatch();

  const { closePopup } = useContext(BasePopupContext)

  const handleSubmit = async () => {
    setLoading(true)
    try {
      const result = await Axios.get(`api/user/subscription-cancel/${data.id}`)
      const access_token = getToken();
            const authUser = getAuthUser();

            // token to save to local storage
            const tokenObj = {
                user: {
                    ...authUser,
                    subscription: {
                        ...authUser.subscription,
                        status: "canceled"
                    } 
                },
                access_token: access_token,
            };
            //saved to local storage
            setToken(tokenObj);

            // // set redux state
            dispatch(login({
              ...authUser,
              subscription: {
                  ...authUser.subscription,
                  status: "canceled"
              } 
            }));
      success_alert(result.data.description)
      closePopup()
      setLoading(false);
    } catch (e) {
      console.log(e)
      if (e.response) {
        error_alert(JSON.stringify(e.response.data.description))
      } else {
        error_alert(network_tl(intl))
      }
      setLoading(false);
    }
  }

  return (
    <>
      <div className='text-gray-600 mb-5 '>
        <FormattedMessage id="cancel_subscription_desc" defaultMessage={"Are you sure you want to cancel your subscription?"} />
      </div>
      <div className='flex justify-end'>
        <button
          onClick={handleSubmit}
          disabled={loading}
          className='btn btn-primary'>
          {
            loading ?
              <BiLoaderAlt className='text-xl mx-auto text-white animate-spin' />
            :
              <FormattedMessage id="yes_proceed" defaultMessage={"Yes, Proceed"} />

          }
        </button>
      </div>

    </>
  )
}

export default Cancel